"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetGroupObjectives = void 0;
const react_query_1 = require("react-query");
const adminClient_1 = require("client/adminClient");
const groupObjectivesKeys_1 = __importDefault(require("consts/queryKeys/groupObjectivesKeys"));
const useGetGroupObjectives = (page, group, options) => {
    return (0, react_query_1.useInfiniteQuery)(groupObjectivesKeys_1.default.group(page, group), ({ pageParam }) => (0, adminClient_1.getPlacementInfo)(group, pageParam), {
        getNextPageParam: (data) => {
            const nextOffset = data?.data?.metadata?.pagination?.nextOffset || null;
            return { offset: nextOffset };
        },
        ...options
    });
};
exports.useGetGroupObjectives = useGetGroupObjectives;
